import React, { useEffect, useState } from 'react';
import {
    notificationTypes,
    TYPE_SUCCESS_WITHOUT_MODERATION,
    TYPE_SUCCESS_WITH_MODERATION,
    TYPE_DEFAULT_ERROR,
} from './notification-types';
import * as constants from '../../../../../cp/components/EventPage/Widgets/NewRegistration/constants';
import { ICON_ERROR, ICON_SUCCESS } from '../../core/constants';
import replacePlaceholders from '../../core/helpers/replacePlaceholders';
import getCapitalizedLocale from '../../../../../platform/src/helpers/get-capitalized-locale';
import UIButton from '../../../../../globalComponents/UIComponents/UIButton';

import { RenderIcon } from '../../components/Icons';
import NotificationsFooter from './NotificationsFooter';

import './style.scss';

const Notifications = ({
    $locale,
    eventKey,
    eventName,
    accessPreModeration,
    yaCode,
    clientEmail = '{{userEmail}}',
    placeholdersData,
    settings,
    isSuccess,
    onCloseNotification,
}) => {
    const [notificationType, setNotificationType] = useState('');
    const locale = getCapitalizedLocale($locale.name);
    const title = replacePlaceholders(settings?.[`${constants.WIDGET_SECOND_SCREEN_TITLE}${locale}`], placeholdersData) || '';
    const subtitle = replacePlaceholders(settings?.[`${constants.WIDGET_SECOND_SCREEN_TEXT}${locale}`], placeholdersData) || '';

    useEffect(() => {
        checkNotificationType(isSuccess);

        if (yaCode && window['yaCounter' + yaCode]) {
            window['yaCounter' + yaCode]['reachGoal'](accessPreModeration
                ? '[COMDI] widget request success'
                : '[COMDI] widget registration success'
            );
        }
    }, [isSuccess]);

    const checkNotificationType = (successed) => {
        if (!successed) {
            setNotificationType(TYPE_DEFAULT_ERROR);

            return;
        };

        setNotificationType(
            accessPreModeration
                ? TYPE_SUCCESS_WITH_MODERATION
                : TYPE_SUCCESS_WITHOUT_MODERATION
        );
    }

    return (notificationType
        ? <div className='registration-nofification'>
            <div className={`registration-nofification__icon ${isSuccess ? 'accent' : ''}`}>
                <RenderIcon iconName={isSuccess ? ICON_SUCCESS : ICON_ERROR} />
            </div>
            {(isSuccess && !settings?.[constants.WIDGET_SECOND_SCREEN_TITLE_HIDDEN]) && (
                <p className='registration-nofification__title'>
                    {title || $locale.get(notificationTypes[notificationType].title, { eventName: eventName || '' })}
                </p>
            )}
            {!isSuccess && (
                <p className='registration-nofification__title'>
                    {$locale.get(notificationTypes[notificationType].title)}
                </p>
            )}
            {(!!notificationTypes[notificationType].message && !settings?.[constants.WIDGET_SECOND_SCREEN_SUBTITLE_HIDDEN]) && (
                <p className='registration-nofification__message'>
                    {subtitle || $locale.get(notificationTypes[notificationType].message, { email: clientEmail })}
                </p>
            )}
            <div className="registration-nofification__actions">
                {!isSuccess &&
                    <UIButton
                        size="large"
                        style={`secondary ${settings?.[constants.WIDGET_PRIMARY_BUTTON_FILLED] === 'bordered' ? 'bordered' : ''}`}
                        onClick={() => onCloseNotification()}
                    >
                        {$locale.get('guide.tryOneMore')}
                    </UIButton>
                }
                {settings?.secondScreenButton &&
                    <a href={settings?.secondScreenButtonLink} target="_blank">
                        <UIButton
                            size="large"
                            style={settings?.secondScreenButtonAccentColor ? "primary" : `secondary bordered`}
                        >
                            {$locale.getProperty(settings, 'secondScreenButtonText')}
                        </UIButton>
                    </a>
                }
            </div>
            {(!accessPreModeration && !settings[constants.WIDGET_CALENDAR_BUTTON_HIDDEN] && isSuccess) && (
                <NotificationsFooter eventKey={eventKey} />
            )}
        </div>
        : <></>
    )
};

export default Notifications;
